import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginGuard } from '../login/login.guard';
import {VendorComponent} from './vendor.component';
import {VendorDetailComponent} from '../vendor-detail/vendor-detail.component';

const routes: Routes = [
  {
    path: 'vendor',
    component: VendorComponent,
    canActivate : [LoginGuard]
  },
  {
    path: 'vendor/new',
    component: VendorDetailComponent,
    canActivate: [LoginGuard]
  },
  {
    path: 'vendor/:id',
    component: VendorDetailComponent,
    canActivate: [LoginGuard]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class VendorRoutingModule { }



// WEBPACK FOOTER //
// /home/pneuser/workspace/pepelogistic/pepeLogisticControl/src/app/vendor/vendor-routing.module.ts